import { Icon, Text, Button } from "@ttc3k/trekker";
import { getMultilingualString } from "shared/utils";
import { WarningWindow } from "iconoir-react";
import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import { Multilingual } from "gql/generated";
import { useHelpScout } from "shared/hooks";

type BroadcastErrorProps = {
  errorType: "DELETED" | "UNPUBLISHED" | "NOT_SHARED_WITH_ME";
  ownerName?: Multilingual;
  onCloseModal: () => void;
};

export const BroadcastError = ({
  errorType,
  ownerName,
  onCloseModal,
}: BroadcastErrorProps) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.BROADCAST.VIEW_MODAL.ERROR",
  });
  const { handleBeaconClick } = useHelpScout();

  return (
    <Flex
      w={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      gap={"400"}
      minH={"90vh"}
    >
      <Flex flexDirection={"column"} gap={"200"} alignItems={"center"}>
        <Icon Element={WarningWindow} size="xl" color="icon.error.mid" />
        {ownerName && (
          <Text
            visual={"bodyMedium"}
            color={"text.mid"}
            w={"full"}
            textAlign={"center"}
          >
            {getMultilingualString(ownerName)}
          </Text>
        )}
      </Flex>

      <Text color={"text.mid"} textAlign={"center"}>
        {t(errorType)}
      </Text>

      <Flex gap={"150"} width={"full"}>
        <Button
          mode={"light"}
          size={"lg"}
          width={"full"}
          onClick={onCloseModal}
          type="button"
        >
          {t("BACK_TO_SITE")}
        </Button>
        <Button
          mode={"light"}
          size={"lg"}
          width={"full"}
          onClick={() => {
            // Delay to avoid autofocus conflict with modal
            setTimeout(() => handleBeaconClick({}), 100);
            onCloseModal();
          }}
          type="button"
        >
          {t("CONTACT_US")}
        </Button>
      </Flex>
    </Flex>
  );
};
